/* eslint-disable react/prop-types */
export default function PromoteAndEarn({
  companyName = 'UTech Dynamics',
  profitShare = 0.3,
  email = 'utechdynamics@gmail.com',
  phone = '+88-0194-403199',
  // whatsapp = '+8801949-403199',
  // website = 'https://www.utechdynamics.com',
}) {
  const profitPct = Math.round(profitShare * 100);
  return (
    <div className="min-h-screen bg-gray-50 text-gray-900">
      {/* Hero */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900" />
        <div className="relative mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-20">
          <div className="grid gap-10 lg:grid-cols-2 items-center">
            <div>
              <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-xs text-white ring-1 ring-white/20">
                <span className="h-2 w-2 rounded-full bg-emerald-400" />
                Contract Opportunity
              </div>
              <h1 className="mt-4 text-4xl font-bold tracking-tight text-white sm:text-5xl">
                Promote & Earn
              </h1>
              <p className="mt-3 max-w-xl text-lg text-gray-200">
                Earn up to
                {' '}
                <span className="font-semibold text-white">
                  {profitPct}
                  % of profit
                </span>
                {' '}
                for every sale you bring to
                {' '}
                {companyName}
                . No fixed hours. No ceiling on earnings.
              </p>
              <div className="mt-8 flex flex-wrap items-center gap-3">
                <a
                  href={`mailto:${email}?subject=Promote%20%26%20Earn%20Inquiry`}
                  className="inline-flex items-center justify-center rounded-2xl px-5 py-3 text-sm font-semibold bg-white text-gray-900 shadow hover:shadow-md transition"
                >
                  Apply via Email
                </a>
                <a
                  href={`tel:${phone.replace(/[^+\d]/g, '')}`}
                  className="inline-flex items-center justify-center rounded-2xl px-5 py-3 text-sm font-semibold ring-1 ring-white/30 text-white hover:bg-white/10 transition"
                >
                  Call Us
                </a>
              </div>
            </div>
            <div className="relative">
              <div className="rounded-3xl bg-white/5 ring-1 ring-white/10 p-6 sm:p-8 backdrop-blur">
                <ul className="grid gap-4 sm:grid-cols-2">
                  {[
                    { title: 'Up to 30% Profit Share', desc: 'Earn per sale you close.' },
                    { title: 'Flexible', desc: 'Work on your schedule.' },
                    { title: 'Ready Assets', desc: 'Demos, decks & pricing.' },
                    { title: 'Global', desc: 'Promote from anywhere.' },
                  ].map((item) => (
                    <li key={item.title} className="rounded-2xl bg-white/10 p-4 ring-1 ring-white/20">
                      <p className="text-sm text-gray-200">{item.desc}</p>
                      <p className="mt-1 font-semibold text-white">{item.title}</p>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid gap-8 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <h2 className="text-2xl font-bold tracking-tight text-gray-900">How it works</h2>
            <p className="mt-2 text-gray-700">
              A simple, transparent process designed for speed.
            </p>
          </div>
          <div className="lg:col-span-7">
            <ol className="grid gap-4 sm:grid-cols-2">
              {[
                { step: 1, title: 'Reach out', text: "Tell us you're interested." },
                { step: 2, title: 'Get assets', text: 'We share product info, demos & pricing.' },
                { step: 3, title: 'Promote & sell', text: 'Use your network to close deals.' },
                { step: 4, title: 'Get paid', text: `Receive up to ${profitPct}% of profit per sale.` },
              ].map((s) => (
                <li key={s.step} className="relative rounded-2xl border border-gray-300 bg-white p-5 shadow-sm">
                  <span className="absolute -top-3 left-4 inline-flex h-7 w-7 items-center justify-center rounded-full bg-gray-900 text-xs font-bold text-white shadow" aria-hidden="true">{s.step}</span>
                  <p className="mt-2 font-semibold text-gray-900">{s.title}</p>
                  <p className="mt-1 text-sm text-gray-700">{s.text}</p>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </section>

      {/* What You Can Promote */}
      <section className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-4">
        <div className="rounded-3xl border border-gray-300 bg-white p-8 shadow-sm">
          <h3 className="text-xl font-semibold text-gray-900">What you can promote</h3>
          <p className="mt-2 text-gray-700">
            Our catalogue includes custom web applications, dashboards, and static websites
            for businesses. We&apos;ll provide quick demos and selling points for each.
          </p>
          <div className="mt-6 grid gap-4 sm:grid-cols-3">
            {['Web Apps', 'Business Dashboards', 'Static Sites'].map((t) => (
              <div key={t} className="rounded-2xl border border-gray-200 p-5">
                <p className="font-medium text-gray-900">{t}</p>
                <p className="mt-1 text-sm text-gray-700">Ready-to-show demos, transparent pricing.</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Terms Snapshot */}
      <section className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid gap-6 lg:grid-cols-12">
          <div className="lg:col-span-7 rounded-3xl border border-gray-300 bg-white p-8 shadow-sm">
            <h3 className="text-xl font-semibold text-gray-900">At a glance: terms</h3>
            <ul className="mt-3 grid gap-3 sm:grid-cols-2">
              <li className="rounded-xl bg-gray-100 p-4">
                <p className="text-sm text-gray-700">Commission</p>
                <p className="font-semibold text-gray-900">
                  Up to
                  {' '}
                  {profitPct}
                  % of profit per sale
                </p>
              </li>
              <li className="rounded-xl bg-gray-100 p-4">
                <p className="text-sm text-gray-700">Tracking</p>
                <p className="font-semibold text-gray-900">Unique lead code or email trail</p>
              </li>
              <li className="rounded-xl bg-gray-100 p-4">
                <p className="text-sm text-gray-700">Payout schedule</p>
                <p className="font-semibold text-gray-900">Within 7 days after client&apos;s payment</p>
              </li>
              <li className="rounded-xl bg-gray-100 p-4">
                <p className="text-sm text-gray-700">Contract type</p>
                <p className="font-semibold text-gray-900">Non-exclusive, per-sale basis</p>
              </li>
            </ul>
            <p className="mt-4 text-xs text-gray-600">
              * Profit means revenue minus delivery costs (e.g., development hours,
              infrastructure, payment fees). Full terms will be confirmed in writing
              per deal.
            </p>
          </div>
          <div className="lg:col-span-5 rounded-3xl border border-gray-300 bg-white p-8 shadow-sm">
            <h3 className="text-xl font-semibold text-gray-900">Ready to start?</h3>
            <p className="mt-2 text-gray-700">Choose a contact option below.</p>
            <div className="mt-6 grid gap-3">
              <a
                href={`mailto:${email}?subject=Promote%20%26%20Earn%20Inquiry&body=Hi%20${encodeURIComponent(companyName)},%0A%0AI'd%20like%20to%20join%20the%20Promote%20%26%20Earn%20program.%20Please%20share%20the%20next%20steps.%0A%0AName:%20%0APhone:%20%0ALocation:%20%0AExisting%20network%20(if%20any):%20%0A`}
                className="rounded-2xl bg-gray-900 px-5 py-3 text-center text-sm font-semibold text-white shadow hover:shadow-md transition"
              >
                Apply via Email
              </a>
              <a
                href={`tel:${phone.replace(/[^+\d]/g, '')}`}
                className="rounded-2xl ring-1 ring-gray-400 px-5 py-3 text-center text-sm font-semibold text-gray-900 hover:bg-gray-50 transition"
              >
                Call
                {' '}
                {phone}
              </a>
              {/* <a
                href={website}
                Learn more on our website
              </a> */}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 pb-20">
        <div className="rounded-3xl border border-gray-300 bg-white p-8 shadow-sm">
          <h3 className="text-xl font-semibold text-gray-900">FAQ</h3>
          <div className="mt-6 grid gap-6 sm:grid-cols-2">
            <div>
              <p className="font-medium text-gray-900">Is this a full-time job?</p>
              <p className="mt-1 text-sm text-gray-700">No. This is a contractual, per-sale opportunity.</p>
            </div>
            <div>
              <p className="font-medium text-gray-900">Who provides pricing and demos?</p>
              <p className="mt-1 text-sm text-gray-700">We do. You&apos;ll receive product sheets, demo links, and selling points.</p>
            </div>
            <div>
              <p className="font-medium text-gray-900">How do you track my leads?</p>
              <p className="mt-1 text-sm text-gray-700">We use unique lead codes or written trails (email/WhatsApp) to attribute sales fairly.</p>
            </div>
            <div>
              <p className="font-medium text-gray-900">When do I get paid?</p>
              <p className="mt-1 text-sm text-gray-700">Within 7 days after the client&apos;s payment clears, as per the agreed scope.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
